import src from "./mail-icon.svg"

const width = 15
const height = 12
export default { src, width, height }
